var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1041_30844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39453 0.951564C8.08008 1.09102 7.875 1.40547 7.875 1.75V3.5H4.8125C2.15469 3.5 0 5.65469 0 8.3125C0 11.4105 2.22852 12.7941 2.73984 13.073C2.8082 13.1113 2.88477 13.125 2.96133 13.125C3.25938 13.125 3.5 12.8816 3.5 12.5863C3.5 12.3813 3.38242 12.1926 3.23203 12.0531C2.975 11.8098 2.625 11.3313 2.625 10.5C2.625 9.05078 3.80078 7.875 5.25 7.875H7.875V9.625C7.875 9.96953 8.07734 10.284 8.39453 10.4234C8.71172 10.5629 9.07812 10.5055 9.33516 10.2758L13.7102 6.33828C13.8934 6.17149 14 5.93633 14 5.6875C14 5.43867 13.8961 5.20352 13.7102 5.03672L9.33516 1.09922C9.07812 0.866798 8.70898 0.809377 8.39453 0.951564Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_30844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.5dd6b5fe7717a48d6afc7233fec2b95a.svg";
export { ForwardRef as ReactComponent };